import { render, staticRenderFns } from "./ReviewsFilterTags.vue?vue&type=template&id=315a3919&"
import script from "./ReviewsFilterTags.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ReviewsFilterTags.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('315a3919')) {
      api.createRecord('315a3919', component.options)
    } else {
      api.reload('315a3919', component.options)
    }
    module.hot.accept("./ReviewsFilterTags.vue?vue&type=template&id=315a3919&", function () {
      api.rerender('315a3919', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/ReviewsFilter/components/ReviewsFilterTags.vue"
export default component.exports